@if (files().length > 0) {
  <div class="flex gap-1.5 items-center w-full overflow-x-auto">
    @for (file of files(); track $index) {
      <div class="flex relative p-1.5 items-center justify-center">
        <div
          class="flex w-14 h-14 items-center justify-center border border-proffeo-border rounded-md bg-proffeo-surface"
        >
          <span
            (click)="onRemoveFile(file)"
            class="flex w-6 h-6 rounded-full bg-proffeo-accent items-center justify-center aspect-square absolute right-0 top-0 cursor-pointer transition-default hover:bg-proffeo-accent/75"
          >
            <mat-icon
              fontIcon="delete"
              class="icon-sm icon-white"
            />
          </span>
          @if (isImage(file)) {
            <img
              [src]="getBlobUrl(file)"
              class="w-14 h-14 rounded-md object-cover"
            />
          } @else {
            <div class="w-14 h-14 flex items-center justify-center rounded-md text-proffeo-muted">
              <mat-icon
                fontIcon="description"
                class="icon-md"
              />
            </div>
          }
        </div>
      </div>
    }
  </div>
}
